import * as yup from 'yup';

export const initialFlowState = {
  isLoading: true,
  isSuccess: '',
  largeImageMessage: '',
  isImageViewOpen: false,
  isButtonLoading: false,
  imageSrcForAction: '',
  isDeleteModalOpen: false,
}

export const initialFormState = {
  nameAm: '',
  nameEn: '',
  nameRu: '',
  positionAm: '',
  positionEn: '',
  positionRu: '',
  mainImageUrl: null,
  visible: true,
  uploadedFileList: null
}

const imageListSchemaOptional = yup.mixed()
  .test(
    'is-files-length',
    'You can upload maximum 5 pictures',
    (value) => Object.keys(value || {}).length <= 5
  )
  .nullable()

export const fileSchema = yup
  .mixed()
  .test('required', 'File is required', (value: any, bbbb: any) => {
    return value && value?.length > 0 || bbbb?.from?.[0]?.value?.images?.length > 0;
  })

export const createTeamSchema = yup.object().shape({
  nameAm: yup.string().required('Name is required.').max(250, 'Name must contain at least maximum length 250'),
  nameEn: yup.string().required('Name is required.').max(250, 'Name must contain at least maximum length 250'),
  nameRu: yup.string().required('Name is required.').max(250, 'Name must contain at least maximum length 250'),
  positionAm: yup.string().optional().max(10000, 'Position must contain at least maximum length 10000').nullable(),
  positionEn: yup.string().optional().max(10000, 'Position must contain at least maximum length 10000').nullable(),
  positionRu: yup.string().optional().max(10000, 'Position must contain at least maximum length 10000').nullable(),
  visible: yup.boolean().required(),
  images: imageListSchemaOptional,
  uploadedFileList: fileSchema,
});
